import React, { useState, useEffect } from "react";
import SideBar from "../Components/SideBar.js";
import "./all_admins.css";
import { useNavigate } from "react-router-dom";
import {API_BASE_URL} from "../config.js";
export default function AllAdmins() {
  const [search, setSearch] = useState("");
  const [admins, setAdmins] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [sortOrder, setSortOrder] = useState("newest");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmins = async () => {
      const token = localStorage.getItem("access_token");

      try {
        setLoading(true);
        setError("");

        const response = await fetch(
          `${API_BASE_URL}/users/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        console.log("USERS RESPONSE:", data);

        if (!response.ok) {
          throw new Error(
            data?.detail || `HTTP error ${response.status}`
          );
        }

        /*
         * /api/users/ يرجع جميع المستخدمين.
         * نحن نريد فقط المستخدمين الذين role عندهم admin.
         */
        const users = Array.isArray(data)
          ? data
          : data.results || [];

        const adminUsers = users.filter(
          (user) => user.role === "admin"
        );

        console.log("ADMINS:", adminUsers);

        setAdmins(adminUsers);
      } catch (err) {
        console.error("Failed to fetch admins:", err);
        setError("حدث خطأ أثناء جلب المدراء.");
        setAdmins([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);

  // البحث والترتيب
  const filteredAdmins = [...admins]
    .filter((admin) => {
      const value = search.toLowerCase().trim();

      if (!value) {
        return true;
      }

      return (
        admin.real_name?.toLowerCase().includes(value) ||
        admin.email?.toLowerCase().includes(value) ||
        admin.phon_number?.toLowerCase().includes(value)
      );
    })
    .sort((a, b) => {
      if (sortOrder === "newest") {
        return b.id - a.id;
      }

      if (sortOrder === "oldest") {
        return a.id - b.id;
      }

      return 0;
    });

  const resetFilters = () => {
    setSortOrder("newest");
    setSearch("");
  };

  return (
    <div className="all-admins-container" dir="rtl">

      {/* SIDEBAR */}
      <div className="all-admins-right">
        <SideBar role="admin" />
      </div>

      <main className="all-admins-left">

        <div className="all-admins-bg-watermark"></div>

        {/* HEADER */}
        <div className="all-admins-header">
          <h1 className="all-admins-title">

            <span
              onClick={() => navigate("/accounts-manager")}
              className="all-admins-link"
            >
              مدير الحسابات
            </span>

            {" / "}

            <span className="all-admins-link active">
              المدراء
            </span>

          </h1>
        </div>

        {/* SEARCH + FILTER */}
        <div className="all-admins-search-row">

          <div className="all-admins-search-container">

            <input
              type="text"
              className="all-admins-search-input"
              placeholder="ابحث عن اسم المدير أو بريده الإلكتروني أو رقم الهاتف..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <i className="fa-solid fa-magnifying-glass all-admins-search-icon"></i>

          </div>

          <button
            className={`all-admins-filter-btn ${
              showFilters ? "active" : ""
            }`}
            onClick={() => setShowFilters(!showFilters)}
            title="فلترة المدراء"
          >
            <i className="fa-solid fa-filter"></i>
          </button>
          
           {/* ADD ADMIN */}
            <button
              className="all-admins-add-btn"
              onClick={() => navigate("/create-account-admin")}
              title="إضافة مدير"
            >
              <i className="fa-solid fa-plus"></i>
            </button>

        </div>

        {/* FILTER PANEL */}
        {showFilters && (
          <div className="all-admins-filter-panel">

            <div className="all-admins-filter-group">

              <label>
                <i className="fa-solid fa-arrow-down-wide-short"></i>
                ترتيب المدراء
              </label>

              <select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="newest">
                  الأحدث أولاً
                </option>

                <option value="oldest">
                  الأقدم أولاً
                </option>
              </select>

            </div>

            <button
              className="all-admins-reset-filter"
              onClick={resetFilters}
            >
              <i className="fa-solid fa-rotate-left"></i>
              إعادة ضبط الفلاتر
            </button>

          </div>
        )}

        {/* CONTENT */}

        {loading ? (

          <div className="all-admins-no-results">
            <i className="fa-solid fa-spinner fa-spin"></i>
            <p>جاري تحميل المدراء...</p>
          </div>

        ) : error ? (

          <div className="all-admins-no-results">
            <i className="fa-solid fa-circle-exclamation"></i>
            <p>{error}</p>
          </div>

        ) : (

          <div className="all-admins-list">

            {filteredAdmins.length > 0 ? (

              filteredAdmins.map((admin) => (

                <div
                  key={admin.id}
                  className="all-admins-card"
                  onClick={() =>
                    navigate(`/admins-profiles/${admin.id}`, {
                      state: {
                        role: "admin",
                      },
                    })
                  }
                >

                  {/* ICON */}
                  <div className="all-admins-icon">
                    <i className="fa-solid fa-user-shield"></i>
                  </div>

                  {/* INFO */}
                  <div className="all-admins-info">

                    <h3 className="all-admins-name">
                      {admin.real_name || "بدون اسم"}
                    </h3>

                    <div className="all-admins-details">

                      <p className="all-admins-code">
                        <i className="fa-solid fa-envelope"></i>
                        البريد الإلكتروني:{" "}
                        {admin.email || "غير متوفر"}
                      </p>

                      <p className="all-admins-code">
                        <i className="fa-solid fa-phone"></i>
                        رقم الهاتف:{" "}
                        {admin.phon_number || "غير متوفر"}
                      </p>

                    </div>

                  </div>

                </div>

              ))

            ) : (

              <div className="all-admins-no-results">

                <i className="fa-solid fa-user-shield"></i>

                <p>
                  {admins.length === 0
                    ? "لا يوجد مدراء مسجلون في النظام"
                    : "لا يوجد مدراء مطابقون للبحث"}
                </p>

              </div>

            )}

           

          </div>

        )}

      </main>

    </div>
  );
}